function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["glyph-inner"] || "glyph-inner",
  d: "M2.5 3A2.5 2.5 0 000 5.5v5A2.5 2.5 0 002.5 13H6v1.94a.98.98 0 001.63.74L10.69 13h.81a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0011.5 3h-9z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["glyph-outer"] || "glyph-outer",
  clipRule: "evenodd",
  d: "M7 12v2.9l3.31-2.9h1.19a1.5 1.5 0 001.5-1.5v-5A1.5 1.5 0 0011.5 4h-9A1.5 1.5 0 001 5.5v5A1.5 1.5 0 002.5 12H7zm.63 3.68A.98.98 0 016 14.94V13H2.5A2.5 2.5 0 010 10.5v-5A2.5 2.5 0 012.5 3h9A2.5 2.5 0 0114 5.5v5a2.5 2.5 0 01-2.5 2.5h-.81l-3.06 2.68z"
}));